<template>
  <div>
    <Navbar v-if="showNavbar" />
    <div
      :style="pageStyles"
    >
      <PortalTarget name="side-menu" class="z-40 row-span-6" />
      <div v-if="showNewAthleteProfile && isLoggedOut && !isUsingProfileKey && !isMobileApp" class="h-24" data-test-id="empty-space">
        <!-- this is here to add space for the otg navbar -->
      </div>
      <PortalTarget
        v-if="showNewAthleteProfile"
        v-show="isLoaded"
        name="top-sticky-bar"
        class="z-40 sticky col-start-2 w-full"
        :style="{ top: showNavbar ? '58px' : '0px'}"
      />
      <LoginPrompt v-if="showNewAthleteProfile && showLogInPrompt" v-show="isLoaded" class="hidden md:block pt-3 bg-white text-center" />
      <PortalTarget
        v-if="showNewAthleteProfile"
        v-show="isLoaded"
        name="identifying-bar"
        class="col-start-2 w-full"
      />
      <LoginPrompt v-if="showNewAthleteProfile && showLogInPrompt" v-show="isLoaded" class="block md:hidden pb-3 bg-white" />
      <PortalTarget
        v-if="showNewAthleteProfile"
        v-show="isLoaded"
        name="secondary-info"
        class="col-start-2"
      />
      <PortalTarget
        v-if="showNewAthleteProfile"
        v-show="isLoaded"
        name="showcase"
        class="col-start-2 bg-white pt-1"
      />
      <PortalTarget
        v-if="showNewAthleteProfile"
        v-show="isLoaded"
        name="navigation-bar"
        class="z-30 sticky col-start-2"
        :style="{top:navigationBarOffset}"
        data-test-id="navigation-bar"
      />
      <div style="flex: 1 1 0" class="col-start-2">
        <AthleteProfileV2
          v-if="showNewAthleteProfile"
          v-show="isLoaded"
          data-test-id="athleteProfileV2"
          :user-id="userId"
          :show-message-button="canSendMessage"
          :show-navbar="showNavbar"
          @loaded="athleteProfileLoaded"
        />
        <AthleteProfile
          v-else
          v-show="isLoaded"
          data-test-id="athleteProfile"
          :user-id="userId"
          :show-message-button="canSendMessage"
          @loaded="athleteProfileLoaded"
        />
        <AthleteProfileLoading v-show="!isLoaded" />
        <OTGSignUpBar v-if="isLoggedOut && !isMobileApp" class="z-50" />
      </div>
    </div>
    <PortalTarget v-if="showNewAthleteProfile" name="flash-alert" />
  </div>
</template>

<script>
import Navbar from "./Navbar";
import AthleteProfileV2 from "./AthleteProfileV2/AthleteProfileV2.vue";
import AthleteProfile from "./AthleteProfile.vue";
import AthleteProfileLoading from "./AthleteProfileLoading";
import OTGSignUpBar from "./OTG/OTGSignUpBar";
import { mapGetters, mapActions, mapMutations } from "vuex";
import * as profileViews from "@/services/profileViews";
import LoginPrompt from "./AthleteProfileV2/LogInPrompt.vue";
import SRCookies from "@/services/cookies";

export default {
  components: {
    Navbar,
    AthleteProfile,
    AthleteProfileV2,
    AthleteProfileLoading,
    OTGSignUpBar,
    LoginPrompt,
  },
  props: {
    userId: { required: true },
    showNewAthleteProfile: { required: true, default: false },
    showLogInPrompt: { required: false, default: '0', type: String },
    useCollegePreferences: { required: false, default: false },
  },
  data() {
    return {
      isLoaded: false,
    };
  },
  computed: {
    ...mapGetters("userData", ["isLoggedOut"]),
    ...mapGetters("athleteProfile", [
      "hasRetrievedBasicInfo",
      "canSendMessage",
      "isApplicableCollegeCoach",
      "isUserWithoutAccess",
    ]),
    isMobileApp() {
      return SRCookies.isMobileSession()
    },
    showNavbar() {
      const response = this.shouldShowNavbar();
      this.setShowSecondaryNavbar(response);
      return response;
    },
    isMobile() {
      return ["xs", "sm", "mobile"].includes(this.$mq);
    },
    navigationBarOffset() {
      if (!this.showNavbar) {
        return this.isMobile ? '47px' : '62px';
      }
      return this.isMobile ? '105px' : '120px';
    },
    pageStyles() {
      return {
        display: this.showNewAthleteProfile ? 'grid' : 'flex',
        gridAutoRows: this.showNewAthleteProfile ? 'auto auto auto auto auto auto 1fr' : 'none',
        gridAutoColumns: this.showNewAthleteProfile ? 'min-content auto' : 'none',
      };
    },
    isUsingProfileKey: () => {
      const query = new URLSearchParams(window.location.search);
      return query.has('k');
    },
  },
  created() {
    profileViews.ready(this.userId);

    this.retrieveUser();
    this.setShowNewAthleteProfile(this.showNewAthleteProfile);
    this.setUseCollegePreferences(!!this.useCollegePreferences);
  },
  methods: {
    ...mapMutations('athleteProfile', ['setShowNewAthleteProfile', 'setShowSecondaryNavbar', 'setUseCollegePreferences']),
    ...mapActions("userData", ["retrieveUser"]),
    athleteProfileLoaded() {
      this.isLoaded = true;
    },
    shouldShowNavbar() {
      if (this.isUserWithoutAccess && this.showNewAthleteProfile) {
        return false;
      }
      if (this.isApplicableCollegeCoach) {
        return this.hasRetrievedBasicInfo && !this.showNewAthleteProfile;
      }
      return this.hasRetrievedBasicInfo && !this.isLoggedOut;
    },
  },
};
</script>
